import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F5F7FA] flex items-center justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-[#0FB4B7] border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!user) return <Navigate to="/tecnico/login" replace />;
  if (adminOnly && user.cargo !== "admin") return <Navigate to="/tecnico/dashboard" replace />;

  return children;
}
